export var PACK_CLASS_PREFIX = 'Pack';
export var PACK_ITEM_CLASS_PREFIX = 'PackItem';
export var packRoot = 'PackRoot';
export var packItemRoot = 'PackItemRoot';